import { ArrowLeftOutlined, CloseOutlined, DeleteOutlined, SaveOutlined, WarningOutlined, } from "@ant-design/icons";
import { Breadcrumb, Button, Modal, Typography } from "antd";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";
import { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useMatches, useNavigate } from "react-router-dom";
import { usePreventRouteChange } from "../../hooks/usePreventRouteChange";
import "./page-header.scss";

type PageHeaderType = {
  arrowLeft?: string;
  subTitle?: string;
  desTitle?: string;
  title?: any;
  removeButton?: boolean;
  headerGroupButton?: boolean;
  accountConfiguration?: boolean;
  tabs?: boolean;
  breadcrumb?: boolean;
  positionItem?: string;
  listBreadcrumb?: ItemType[];
  childrenGroupButton?: ReactNode;
  stateBack?: any;
  goBackPath?: string;
  handleBack?: () => void;
  cancelSave?: () => void;
  saveModalConfirm?: () => void;
};


function useShowBack() {
  const matches = useMatches();
  const location = useLocation();

  const handle = matches[matches.length - 1]?.handle as { backable?: boolean } | undefined;
  if (handle?.backable !== undefined) return handle.backable;

  const segments = location.pathname.split("/").filter(Boolean);
  const looksLikeId = segments.some((segment) =>
    /^(?:\d+|[0-9a-f]{8,}-?[0-9a-f-]*)$/i.test(segment)
  );

  const detailKeywords = [
    "detail",
    "edit",
    "preview",
    "view",
    "approval",
    "evaluation",
    "rate",
    "score",
  ];
  const hasKeyword = detailKeywords.some((k) => segments.includes(k));

  return looksLikeId || hasKeyword;
}

const PageHeader: FunctionComponent<PageHeaderType> = ({
  arrowLeft,
  title,
  desTitle,
  removeButton,
  tabs,
  breadcrumb,
  positionItem,
  listBreadcrumb,
  childrenGroupButton,
  headerGroupButton,
  subTitle,
  accountConfiguration,
  goBackPath,
  handleBack,
  cancelSave,
  saveModalConfirm
}) => {
  const { t } = useTranslation();
  const { confirmNavigation } = usePreventRouteChange();
  const navigate = useNavigate();
  const showBack = useShowBack();
  const removeModal = () => {
    Modal.confirm({
      title: t("Xoá tài khoản", "Xoá tài khoản"),
      content: t("Mọi dữ liệu tài khoản đã xoá sẽ không thể khôi phục. Bạn chắc chắn muốn xoá tài khoản?", "Mọi dữ liệu tài khoản đã xoá sẽ không thể khôi phục. Bạn chắc chắn muốn xoá tài khoản?"),
      icon: <WarningOutlined />,
      okType: "danger",
      cancelText: t("common.cancel", "Huỷ"),
      okText: t("common.confirm", "Xác nhận"),
      wrapClassName: "modal-custom",
      onCancel: () => {
      },
    });
  };

  const cancelModal = () => {
    Modal.confirm({
      title: t("Xác nhận hủy", "Xác nhận hủy"),
      content: t("Bạn có chắc chắn muốn hủy các thông tin vừa chỉnh sửa?", "Bạn có chắc chắn muốn hủy các thông tin vừa chỉnh sửa?"),
      okType: "primary",
      cancelText: t("common.close", "Đóng"),
      okText: t("common.confirm", "Xác nhận"),
      wrapClassName: "modal-custom",
      onOk: () => {
        if (cancelSave) {
          cancelSave()
        }
      },
    });
  };

  const saveModal = () => {
    if (saveModalConfirm) {
      saveModalConfirm()
    }
  }

  return (
    <div className={`page-header ${positionItem ? "item-vertical" : ""} ${!breadcrumb ? "only-title" : ""}`} id="page-header">
      {breadcrumb && <Breadcrumb items={listBreadcrumb?.map((b) => ({ ...b, title: typeof b.title === "string" ? t(b.title, b.title) : b.title }))} />}
      <div className="page-heading">
        <div className="heading-left">
          {showBack && <ArrowLeftOutlined
            className="header-back-icon"
            onClick={() => {
              confirmNavigation({ link: '' }, false, () => {
                if (goBackPath) navigate(goBackPath);
                else navigate(-1);
              });
            }}
          />}
          {/* {arrowLeft && location.state?.modeback === 'backState' && location.state !== null && (
            <ArrowLeftOutlined
              className="header-back-icon"
              onClick={() => {
                confirmNavigation({ link: location.state.backLink, path: { state: location.state } });
              }}
            />
          )} */}
          {arrowLeft && handleBack && (
            <ArrowLeftOutlined
              className="header-back-icon"
              onClick={() => {
                handleBack();
              }}
            />
          )}
          {/* <h3 className="title54">{`${subTitle ?? ''} ${title}`}</h3> */}
          <div className="heading-left-content">
            <p className="title54">{typeof subTitle === "string" ? t(subTitle, subTitle) : subTitle}</p>
            <div className="title54 flex">
              <div className="page-header-title">
                {typeof title === 'string' ? (
                  <span dangerouslySetInnerHTML={{ __html: t(title, title) }} />
                ) : (
                  title
                )}
              </div>
              <p className="des-title">{typeof desTitle === "string" ? t(desTitle, desTitle) : desTitle}</p>
            </div>
          </div>
        </div>
        {removeButton && (
          <div className="heading-right">
            <Button className="btn btn-remove" onClick={removeModal}>
              <DeleteOutlined />
              <Typography.Text>{t("Xoá tài khoản", "Xoá tài khoản")}</Typography.Text>
            </Button>
          </div>
        )}
        {headerGroupButton && (<div className="heading-right">{childrenGroupButton}</div>)}
        {accountConfiguration && (
          <div className="heading-right flex gap-2">
            <Button className="" onClick={cancelModal}>
              <CloseOutlined />
              <Typography.Text>{t("common.cancel", "Hủy")}</Typography.Text>
            </Button>
            <Button className="" type="primary" onClick={saveModal}>
              <SaveOutlined />
              <Typography.Text>{t("common.save", "Lưu")}</Typography.Text>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;